'use client';

import BackgroundVideo from '@/components/background-video';
import ctaPoster from '@images/blog-cta-poster.webp';

// 영상·poster 파일은 scripts/encode-blog-cta-video.sh 가 만든다.
export default function BlogCtaBackgroundVideo({
  className,
}: {
  className?: string;
}) {
  return (
    <BackgroundVideo
      poster={ctaPoster}
      name="blog-cta"
      wideRes="1920"
      narrowRes="960"
      className={className}
    />
  );
}
